export default "__VITE_ASSET__DKuiNKNY__"